module.exports = __webpack_public_path__ + "media/luxury-2026/twilight-modern-2acb0cfc.jpg";